import { render, staticRenderFns } from "./ReferenceFileWidget.vue?vue&type=template&id=613fea0c&scoped=true"
import script from "./ReferenceFileWidget.vue?vue&type=script&lang=ts"
export * from "./ReferenceFileWidget.vue?vue&type=script&lang=ts"
import style0 from "./ReferenceFileWidget.vue?vue&type=style&index=0&id=613fea0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613fea0c",
  null
  
)

export default component.exports